import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import Header from '../components/header/header';
import ReactModal from 'react-modal'
import SidebarOperacion from '../components/header/sidebarOperacion';
import SearchHouse from "../components/propietarios/search-house";
import { Consumer,Context } from "../context";
import ReservationTable from '../components/commonAreasReservation/reservationTable2'
import Controls from '../components/controls/controls';
import Paginador from "../components/paginador/paginador";
import DinamicModal from '../components/dinamicModal/dinamicModal';
import Request from "../core/httpClient";
import moment from 'moment-timezone';
import Permissions from '../middlewares/Permissions';
import cogoToast from 'cogo-toast';
import Core from './../components/core/SuperCore';
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';
/**Socket */
import Socket from '../core/socket';
import { useSuperCore } from '../hooks/useSuperCore';
import { useContext } from 'react';



registerLocale('es', es)

const request = new Request();



function CommonAreasReservation2(props) {
	const context = useContext(Context);
  const [lectura, setLectura] = useState(false);
  const [escritura, setEscritura] = useState(false);
  const [logo] = useState(require("../img/logo-AppMosphera-r.png"));
  const [filter, setFilter] = useState('');

  // Datos de reservas y fraccionamientos
  const [reservas, setReservas] = useState([]);
  const [subfraccionamientos, setSubfraccionamientos] = useState([]);
  const [idSubfraccionamiento, setIdSubfraccionamiento] = useState(localStorage.getItem('subfrac') || 0);
  const [idSubfraccionamientoTraerViviendas, setIdSubfraccionamientoTraerViviendas] = useState(localStorage.getItem('subfrac') || 0);

  // Viviendas y áreas
  const [unidades, setUnidades] = useState([]);
  const [idUnidad, setIdUnidad] = useState(0);
  const [areas, setAreas] = useState([]);
  const [idArea, setIdArea] = useState(0);

  // Fecha y horarios
  const [fecha, setFecha] = useState(null);
  const [minDay, setMinDay] = useState(null);
  const [horarios, setHorarios] = useState([]);
  const [idHorario, setIdHorario] = useState(0);

  // Aforo y personas
  const [aforo, setAforo] = useState(false);
  const [maxAforo, setMaxAforo] = useState(null);
  const [maxReservasAforo, setMaxReservasAforo] = useState(null);
  const [personas, setPersonas] = useState(1);

  // Usuario y datos adicionales
  const [usuario, setUsuario] = useState({});
  const [fianza, setFianza] = useState(null);
  const [comentarios, setComentarios] = useState('');

  // Paginación y UI
  const [page, setPage] = useState(1);
  const [pageLength, setPageLength] = useState(20);
  const [submenu, setSubmenu] = useState('');
  const [subLabel, setSubLabel] = useState('');

  // Estados de guardado
  const [loading, setLoading] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [messageSave, setMessageSave] = useState('');
  const { getUserInfo, openModal, closeModal } = useSuperCore();

  const clearData = () => {
  setComentarios('');
  setFianza(null);
};


const changeSubfraccionamiento = async (event) => {
  const id_sub = event.target.value;

  // Resetear estados relacionados
  setUnidades([]);
  setAreas([]);
  setIdUnidad(0);
  setIdArea(0);
  setHorarios([]);
  setIdHorario(0);
  setFecha(null);

  // Actualizar subfraccionamiento
  setIdSubfraccionamiento(id_sub);
  setIdSubfraccionamientoTraerViviendas(id_sub);

  // Cargar datos dependientes
  await getUnidades();
  await getAreasComunes();
  await getHorarios();
};
const changeDate = async (newFecha) => {
  setFecha(newFecha);
  setHorarios([]);
  setIdHorario(0);
  setAforo(false);
  setMaxAforo(null);
  setMaxReservasAforo(null);

  await getHorarios();
};


const changeHorario = (event) => {
  setAforo(false);
  setMaxAforo(null);
  setMaxReservasAforo(null);

  const horarioSeleccionado = horarios.filter(
    (h) => h.id_horario === parseInt(event.target.value)
  );

  let aforoFlag = false, maxReservas = null, disponible = null;

  if (horarioSeleccionado.length !== 0) {
    aforoFlag = horarioSeleccionado[0].maxAforo !== 0 && horarioSeleccionado[0].maxAforo !== null;
    maxReservas = horarioSeleccionado[0].maxReservasAforo;
    disponible = horarioSeleccionado[0].disponible;
  }

  const id_horario = event.target.value;
  setIdHorario(id_horario);
  setAforo(aforoFlag);
  setMaxAforo(disponible);
  setMaxReservasAforo(
    aforoFlag
      ? maxReservas !== null
        ? (maxReservas < disponible ? maxReservas : disponible)
        : disponible
      : null
  );
};


  const handleSubmit = async (event) => {
  event.preventDefault();
  setLoadingSave(true);
  setMessageSave('');

  let validado = true;

  if (idHorario == null || idHorario === 0) {
    cogoToast.warn('Debes elegir un horario', { position: 'bottom-right' });
    validado = false;
  }

  if (idUnidad == null || idUnidad === 0) {
    cogoToast.warn('Debes elegir una unidad.', { position: 'bottom-right' });
    validado = false;
  }

  if (idArea == null || idArea === 0) {
    cogoToast.warn('Debes elegir un área.', { position: 'bottom-right' });
    validado = false;
  }

  if (!validado) {
    setLoadingSave(false);
    return;
  }

  // Construir fecha en formato YYYY-MM-DD
  let f = fecha;
  let fechaStr = `${f.getFullYear()}`;
  fechaStr += `-${f.getMonth() + 1 < 10 ? `0${f.getMonth() + 1}` : f.getMonth() + 1}`;
  fechaStr += `-${f.getDate()}`;

  let data = {
    idFracc: localStorage.getItem('frac'),
    idHorario: parseInt(idHorario),
    area: parseInt(idArea),
    fecha: fechaStr,
    idviv: parseInt(idUnidad),
    idUsuario: parseInt(usuario.id_usuario),
    fianza: fianza,
    comentarios: comentarios,
    diferencia: 0, // necesario para el SP
    fecha_local: moment().format('YYYY-MM-DD HH:mm:ss'),
    personas: aforo ? personas : null,
  };

  const response = await request.post("/commonArea/save/reservation", data);

  if (response.error) {
    let msj = response.message || 'No se pudo agregar nueva reserva.';
    if (response.status) {
      if (response.status.status === -1) msj = 'El límite de reservas anual ha sido superado.';
      if (response.status.status === -2) msj = 'El límite de reservas consecutivas ha sido superado.';
      if (response.status.status === -3) msj = 'El horario del área seleccionada ya se encuentra reservado.';
      if (response.status.status === -4) msj = 'El límite de reservas por categoría se ha superado.';
      if (response.status.status === -5) msj = 'Esta vivienda ya cuenta con una reserva para este horario.';
      if (response.status.status === -6) msj = 'Ya no hay disponibilidad para este horario, por favor seleccione otro.';
    }

    cogoToast.error(msj, { position: 'bottom-right' });
    setLoadingSave(false);
    return;
  }

  if (response.created) {
    closeModal("newReservation"); // usando tu helper de SuperCore
    clearData();
    cogoToast.success('Área reservada correctamente.', { position: 'bottom-right' });
    await getNuevaReservacionInfo();
  }

  setLoadingSave(false);
};


const getHorarios = async (didmount = false) => {
  // Reiniciar horarios
  setHorarios([]);
  setIdHorario(0);

  if (fecha) {
    // Construir fecha en formato YYYY-MM-DD
    let fechaStr = `${fecha.getFullYear()}`;
    fechaStr += `-${fecha.getMonth() + 1 < 10 ? `0${fecha.getMonth() + 1}` : fecha.getMonth() + 1}`;
    fechaStr += `-${fecha.getDate()}`;

    const data = {
      id_espacio: parseInt(idArea),
      fecha: moment(`${fechaStr} ${moment().format('HH:mm:ss')}`).format('YYYY-MM-DD HH:mm:ss'),
      id_vivienda: parseInt(idUnidad),
      fecha_actual: moment().format('YYYY-MM-DD HH:mm:ss')
    };

    const response = await request.post("/commonArea/get/available/aforo", data);

    if (response.commonSchedules) {
      if (response.commonSchedules.length !== 0) {
        if (response.commonSchedules[0].error !== null) {
          setHorarios([]);
          setAforo(false);
          setMaxAforo(null);
          setMaxReservasAforo(null);

          if (!didmount) {
            cogoToast.info(response.commonSchedules[0].message, {
              position: 'bottom-right',
            });
          }
          return;
        } else {
          const aforoFlag = response.commonSchedules[0].maxAforo !== 0 && response.commonSchedules[0].maxAforo !== null;
          const maxReservas = response.commonSchedules[0].maxReservasAforo;
          const disponible = response.commonSchedules[0].disponible;

          setHorarios(response.commonSchedules);
          setIdHorario(response.commonSchedules[0].id_horario);
          setAforo(aforoFlag);
          setMaxAforo(disponible);
          setMaxReservasAforo(
            aforoFlag
              ? maxReservas !== null
                ? (maxReservas < disponible ? maxReservas : disponible)
                : disponible
              : null
          );
        }
      } else {
        setHorarios([]);
        setAforo(false);
        setMaxAforo(null);
        setMaxReservasAforo(null);

        if (!didmount) {
          cogoToast.info('No se encontraron horarios para el área común seleccionada.', {
            position: 'bottom-right',
          });
        }
        return;
      }
    }
  }
};

  const getReservas = async () => {
  setLoading(true);
  const data = {
    Id: parseInt(localStorage.getItem('frac') || 0),
    fecha: moment().format('YYYY-MM-DD'),
    IdSub: parseInt(localStorage.getItem('subfrac') || 0)
  };

  const response = await request.post("/commonArea/get/reservas", data);

  if (response.error || response.empty) {
    setReservas([]);
    setLoading(false);
    cogoToast.info('No se encontraron reservas.', { position: 'bottom-right' });
    return;
  }

  if (response.info) {
    setReservas(response.info);
  }
  setLoading(false);
};


  // Migración de getSubfraccionamientos
  const getSubfraccionamientos = async () => {
    const fraccionamiento = localStorage.getItem('frac');
    const subfraccionamiento = localStorage.getItem('subfrac');
    if (!fraccionamiento) return;

    let data = { Idsub: fraccionamiento, filter: 1 };
    const response = await request.post("/admin/administracion/get/subfraccionamientos", data);

    if (response.error || response.empty) {
      setSubfraccionamientos([]);
      return;
    }

    if (response.subfraccionamiento) {
      setSubfraccionamientos(response.subfraccionamiento);
      setIdSubfraccionamiento(subfraccionamiento);
    }
  };

  // Ejemplo de changeUnidad
  const changeUnidad = (event) => {
    setIdUnidad(event.target.value);
  };

  // Ejemplo de changeAreaComun
  const changeAreaComun = async (event) => {
    const id_area = event.target.value;
    setFecha(null);
    setHorarios([]);
    setIdHorario(0);
    setAforo(false);
    setMaxAforo(null);
    setMaxReservasAforo(null);

    const area = areas.find(a => a.id_espacio == id_area);
    setIdArea(id_area);
    if (area) {
      delimitarSeleccionFechas(area);
      await getHorarios();
    }
  };

  const delimitarSeleccionFechas = (areaSeleccionada) => {
    let min_day = moment().add(parseInt(areaSeleccionada.dias_anticipacion), 'days');
    setMinDay(min_day.toDate());
    setFecha(min_day.toDate());
  };


  // validar permisos
  const validarPermisos = async () => {
    let permisos = new Permissions();
    let permisosInfo = await permisos.getResult();
    setEscritura(permisosInfo.escritura);
    setLectura(permisosInfo.lectura);
  };

  const subChange = async (sub) => {
    setIdSubfraccionamiento(sub);
    setIdSubfraccionamientoTraerViviendas(sub);
    await getNuevaReservacionInfo();
  };

  const paginatorChange = async (length) => {
    setPageLength(length);
    // reset page to 1 (si manejas paginación externa)
  };
  const getUnidades = async () => {
  // Reiniciar unidades
  setUnidades([]);
  setIdUnidad(0);

  const data = {
    id_fraccionamiento: localStorage.getItem('frac'),
    id_subfraccionamiento: idSubfraccionamientoTraerViviendas
  };

  const response = await request.post("/viviendas/getViviendaBySubFraccionamiento", data);

  if (response.empty || response.error) {
    setUnidades([]);
    cogoToast.info('No se encontraron unidades en este fraccionamiento.', {
      position: 'bottom-right',
    });
    return;
  }

  if (response.viviendas) {
    setUnidades(response.viviendas);
    setIdUnidad(response.viviendas[0].id_vivienda);
  }
};

const getAreasComunes = async () => {
  // Reiniciar áreas
  setIdArea(0);
  setAreas([]);

  const data = {
    id: localStorage.getItem('frac'),
    idsubfrac: idSubfraccionamiento
  };

  const response = await request.post("/commonArea/get/info", data);

  if (response.empty || response.error) {
    setAreas([]);
    cogoToast.info('No se encontraron áreas comunes en este subfraccionamiento.', {
      position: 'bottom-right',
    });
    return;
  }

  if (response.info) {
    const primerArea = response.info[0];
    setAreas(response.info);
    setIdArea(primerArea.id_espacio);

    // Delimitar fechas
    delimitarSeleccionFechas(primerArea);
  }
};


  const getNuevaReservacionInfo = async () => {
    await getReservas();
    await getSubfraccionamientos();
    await getUnidades();
    await getAreasComunes();
    await getHorarios(true);
  };

  const getSubmenu = async () => {
    const submenuValue = await context.getSubmenuOpeName('areas', 'reservas');
    if (submenuValue) setSubmenu(submenuValue);

    const subLabelValue = window.localStorage.getItem('subLabel');
    if (subLabelValue) setSubLabel(subLabelValue);
  };

  // ciclo de vida: componentDidMount
useEffect(() => {
  const init = async () => {
    // 1. Validar permisos
    await validarPermisos();

    // 2. Submenú y etiqueta
    await getSubmenu();

    // 3. Cargar información inicial (reservas, unidades, áreas, horarios)
    await getNuevaReservacionInfo();

    // 4. Obtener info del usuario
    const user = await getUserInfo();
    setUsuario(user.info);
  };

  // Ejecutar inicialización
  init();

  // Suscripción al socket: refresca reservas cuando llega un evento
  Socket.on('newReservaAreaComun', () => {
    getReservas(); // aquí está tu lógica con await request.post(...)
  });

  // Cleanup para evitar fugas de memoria
  return () => {
    Socket.off('newReservaAreaComun');
  };
}, []);

// Refrescar automáticamente cuando cambia el subfraccionamiento
useEffect(() => {
  if (idSubfraccionamiento) {
    getNuevaReservacionInfo();
  }
}, [idSubfraccionamiento]);

  // componentDidUpdate -> se maneja con useEffect dependiente
  // ejemplo: si quieres reaccionar a cambios de idSubfraccionamiento
  useEffect(() => {
    if (idSubfraccionamiento) {
      getNuevaReservacionInfo();
    }
  }, [idSubfraccionamiento]);

const renderReservationPage = () => {
  let reservasFiltradas = [];
  if (Array.isArray(reservas)) {
    reservasFiltradas = reservas.filter(r =>
      JSON.stringify(r).toLowerCase().includes(filter.toLowerCase())
    );
  }

  return (
    <div className="houses column">
      <Helmet>
        <title>{process.env.REACT_APP_NAME} - {submenu}</title>
      </Helmet>
      <Header
        sidebar={true}
        active={'reservas'}
        parent={'areas'}
        panel={'panel3'}
        nav={"operacion"}
      />
      <div className="row">
        <div className="column" id="sidebar">
          <SidebarOperacion />
        </div>
        <div className="column" id="content">
          <div className="justify-center">
            <div className="container column">
              {lectura && (
                <>
                  <Controls
                    title={submenu}
                    nuevo={() => openModal("newReservation")}
                    dataSet={reservasFiltradas}
                    dateFormat="dd/mm/yyyy"
                    setFilter={(f) => setFilter(f.toLowerCase())}
                    subChange={subChange}
                    newButton={escritura}
                  />
                  {loading ? (
                    <div className="row justify-center">
                      <i className="fas fa-spinner fa-spin"></i>
                    </div>
                  ) : (
                    <ReservationTable
                      reservas={reservasFiltradas}
                      page={page}
                      user={usuario}
                      reload={getNuevaReservacionInfo}
                      escritura={escritura}
                      pageLength={pageLength}
                    />
                  )}
                  <div className="white-space-16"></div>
                  <Paginador
                    pages={Math.ceil(reservasFiltradas.length / pageLength)}
                    setPage={setPage}
                    pageLength={pageLength}
                    paginatorChange={paginatorChange}
                    showPageLenght={true}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <DinamicModal
        idModal={'newReservation'}
        sizeModalContainer={'big'}
        title={'Añadir reserva'}
        success={handleSubmit}
        btnTextSuccess={"GUARDAR"}
        btnTextCancel={"CANCELAR"}
        showBtnSuccess={true}
        showBtnCancel={true}
        loadingSave={loadingSave}
        message={messageSave}
      >
        {renderNewReservation()}
      </DinamicModal>
    </div>
  );
};

const renderNewReservation = () => (
  <div className="w-full space-y-6">
    {/* Subfraccionamiento */}
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {subLabel}:
      </label>
      <select
        className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
        value={idSubfraccionamiento}
        disabled={(localStorage.getItem('subfrac') || 0) !== 0}
        onChange={changeSubfraccionamiento}
        required
      >
        {subfraccionamientos.map((sub, key) => (
          <option value={sub.id_subfraccionamiento} key={key}>
            {sub.nombre}
          </option>
        ))}
      </select>
    </div>

    {/* Unidad */}
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Unidad:
      </label>
      <select
        className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
        value={idUnidad}
        onChange={changeUnidad}
        required
      >
        {unidades.map((unidad, key) => (
          <option value={unidad.id_vivienda} key={key}>
            {unidad.numero_registro}
          </option>
        ))}
      </select>
    </div>

    {/* Áreas */}
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Áreas:
      </label>
      <select
        className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
        value={idArea}
        onChange={changeAreaComun}
        required
      >
        {areas.map((area, key) => (
          <option value={area.id_espacio} key={key}>
            {area.nombre}
          </option>
        ))}
      </select>
    </div>

    {/* Fecha y Horario */}
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Fecha:
        </label>
        <DatePicker
          className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm bg-gray-100 focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
          selected={fecha}
          onChange={changeDate}
          dateFormat="dd/MM/yyyy"
          locale="es"
          minDate={minDay}
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Horario:
        </label>
        <select
          className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
          value={idHorario}
          onChange={changeHorario}
          required
        >
          {horarios.map((h, key) => (
            <option value={h.id_horario} key={key}>
              {h.descripcion}
            </option>
          ))}
        </select>
      </div>
    </div>

    {/* Aforo */}
    {aforo && (
      <>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Aforo disponible:
            </label>
            <input
              className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm bg-gray-100"
              disabled
              type="number"
              value={maxAforo}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              No. personas:
            </label>
            <input
              className="block w-full rounded-md border border-gray-300  bg-gray-100 px-3 py-2 text-sm focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
              type="number"
              min={1}
              max={maxReservasAforo}
              value={personas}
              onChange={(e) => setPersonas(parseInt(e.target.value))}
            />
          </div>
        </div>
        <p className="text-xs text-red-600 text-right">
          Máximo a reservar: {maxReservasAforo} persona(s)
        </p>
      </>
    )}

    {/* Fianza y Usuario */}
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Depósito fianza:
        </label>
        <input
          className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm bg-gray-100 focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
          type="number"
          min={0}
          value={fianza || ''}
          onChange={(e) => setFianza(e.target.value)}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Recibido por:
        </label>
        <input
          className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm bg-gray-100"
          type="text"
          disabled
          value={usuario.usuario || ''}
        />
      </div>
    </div>

    {/* Comentarios */}
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Comentarios:
      </label>
      <textarea
        className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm bg-gray-100 focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
        rows="3"
        value={comentarios}
        onChange={(e) => setComentarios(e.target.value)}
      ></textarea>
    </div>
  </div>
);



    return renderReservationPage();
}
export default CommonAreasReservation2;
